import { store } from '@store'

export default role => {
  return function ({next}) {
    store.commit('auth/setAuthRole', role)
    return next();
  }
}
